export const RESOURCE_TYPE_UIF_BOARD = 'UIF_BOARD';
